// extracted by mini-css-extract-plugin
export default {"container":"LoadingUserAvatar_container__g-jr0","loader":"LoadingUserAvatar_loader__kdYbp"};